/**
 * Contact Us — KidHive.
 */
const content = [
  {
    type: 'p',
    text:
      "If you have any questions or concerns, please email us at info@kidhive.co or message us on [Instagram](https://www.instagram.com/kidhive.co) — we'll respond promptly.",
  },
];

export default content;
